import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, FormGroup, Validators, FormBuilder} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {ConfirmValidParentMatcher, CustomValidators, errorMessages, regExps} from '@app/app/profile/custom-validators';

@Component({
  selector: 'change-password-dialog',
  templateUrl: 'change-password-dialog.html',
  styleUrls: ['../controller/controller.css']
})

export class ChangePasswordDialogComponent implements OnInit {

  public passwordForm: FormGroup;
  @Input() new_password = '';
  @Input() confirmed_password = '';
  public success = '';
  public error = '';
  public isRunning = false;
  confirmValidParentMatcher = new ConfirmValidParentMatcher();
  errors = errorMessages;

  constructor(public dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient, private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.passwordForm = this.formBuilder.group({
      password: ['', [Validators.required]],
      passwordGroup: this.formBuilder.group({
        new_password: ['', [Validators.required, Validators.pattern(regExps.password)]],
        confirmed_password: ['', [Validators.required]]
      }, {validator: CustomValidators.passwordsMatch})
    });
  }

  onSubmit({value, valid}) {
    if (valid) {
      const body = {
        data: {
          type: 'Passwords',
          attributes: {
            current_password: value.password,
            new_password: value.passwordGroup.new_password
          }
        }
      };

      this.isRunning = true;

      this.http.put('/passwords', body).subscribe(() => {
          // this.success = 'The password was updated.';
          this.isRunning = false;
          this.dialogRef.close('The password was updated.');
        },
        (err) => {
          this.error = 'Wrong password';
          this.isRunning = false;
        });
    }
  }

  onCloseCancel() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/change-password-dialog.component.ts